import { ClientError, APIError, MutationFn, UseQueryFn } from 'shared-ui';

import { User } from 'api/users/users.types';

import { LoginBody, LoginResponse, LoginErrorResponse, AppVersionResponse, PasswordPolicy } from './auth.types';

export const onLogin: MutationFn<LoginBody, LoginResponse, ClientError<APIError<LoginErrorResponse>>> = (body) => {
  return {
    endpoint: '/auth/login',
    method: 'POST',
    body,
  };
};

export const getAppVersion: UseQueryFn<void, AppVersionResponse> = () => {
  return {
    endpoint: `/version`,
  };
};

export const onLogout: MutationFn<void, void, ClientError<APIError<unknown>>> = () => {
  return {
    endpoint: '/auth/logout',
    method: 'POST',
  };
};

//TODO Sprawdzic endpoint
export const logoutUser: MutationFn<string, User> = (id) => {
  return {
    endpoint: `/auth/${id}/logout`,
    method: 'POST',
  };
};

//TODO Sprawdzic endpoint
export const fetchPasswordPolicy: UseQueryFn<void, PasswordPolicy> = () => {
  return {
    endpoint: '/setting/password-policy',
  };
};

//TODO Sprawdzic endpoint
export const updatePasswordPolicy: MutationFn<{ body: PasswordPolicy }, void> = ({ body }) => {
  return {
    endpoint: '/setting/password-policy',
    method: 'POST',
    body,
  };
};
